import { render, staticRenderFns } from "./ImageGroupDetailModal.vue?vue&type=template&id=c25babe2&scoped=true"
import script from "./ImageGroupDetailModal.vue?vue&type=script&lang=js"
export * from "./ImageGroupDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ImageGroupDetailModal.vue?vue&type=style&index=0&id=c25babe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25babe2",
  null
  
)

export default component.exports